import { StateCreator } from 'zustand'

import { IUser } from '../../api/types'

export type Store = {
  authUser: IUser | null;
  userCredentials: {
    token: string;
  };
  requestLoading: boolean;
};

export type Actions = {
  setAuthUser: (user: IUser | null) => void;
  setRequestLoading: (isLoading: boolean) => void;
  setCredentials: (credentials: { token: string }) => void;
};

export type AuthSlice = Store & Actions;

export const createAuthSlice: StateCreator<
AuthSlice,
[],
[],
AuthSlice
> = (set) => ({
  authUser: null,
  requestLoading: false,
  userCredentials: {
    token: ''
  },
  setAuthUser: (user) => set((state) => ({ ...state, authUser: user })),
  setRequestLoading: (isLoading) => set((state) => ({ ...state, requestLoading: isLoading })),
  setCredentials: (credentials) => set((state) => ({ ...state, userCredentials: credentials }))
})
